import { render, staticRenderFns } from "./SundryCreditorListSideMenu.vue?vue&type=template&id=4ce67776&scoped=true"
import script from "./SundryCreditorListSideMenu.vue?vue&type=script&lang=js"
export * from "./SundryCreditorListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./SundryCreditorListSideMenu.vue?vue&type=style&index=0&id=4ce67776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce67776",
  null
  
)

export default component.exports